<template>
  <div class="card">
    <div class="card__video" :class="[{'video-open': videoOpen}]">
      <div
        class="card__video_wrapper"
        @click.stop="setVideoOpen(false)"
      >
        <video
          :controls="controls || videoOpen"
          :autoplay="autoplay"
          playsinline
          :muted="muted"
          :loop="loop"
          class="video"
          :poster="videoPoster"
          @click.stop="setVideoOpen(true)"
        >
          <source v-for="video in srcVideo" :src="video" />
        </video>
      </div>
    </div>
    <div class="card__title" v-if="title">
      <div class="number" v-if="titleNumber">{{ titleNumber }}</div>
      <div class="number" v-else-if="titleSvg">
        <component :is="titleSvg" />
      </div>
      <div class="title">{{ $t(title) }}</div>
    </div>
    <div class="card__subtitle">{{ $t(subTitle) }}</div>
    <div
      class="close-box"
      @click.stop="setVideoOpen(!videoOpen)"
      v-if="videoOpen"
    >
      <div class="one"></div>
      <div class="two"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    srcVideo: string[] | undefined;
    title?: string;
    titleNumber?: number;
    titleSvg?: SVGAElement;
    subTitle?: string;
    controls?: boolean;
    autoplay?: boolean;
    muted?: boolean;
    loop?: boolean;
    videoPoster?: string;
  }>(),
  {
    srcVideo: undefined,
    title: '',
    titleNumber: undefined,
    titleSvg: undefined,
    subTitle: '',
    autoplay: false,
    muted: true,
    loop: true,
    videoPoster: undefined,
  },
);
const videoOpen = ref(false);
const setVideoOpen = (isVideoOpen: boolean) => {
  videoOpen.value = isVideoOpen;
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
  width: fit-content;
  height: 100%;
  position: relative;
  border-radius: $br-1;
  gap: $g-6;
  font-size: $fs-18;

  &__video {
    cursor: pointer;
    .video {
      width: 100%;
      object-fit: cover;
      box-shadow: 0px 0px 8px 0px rgba(24, 25, 26, 0.08),
        0px 0px 16px 0px rgba(24, 25, 26, 0.12),
        0px 0px 32px 0px rgba(24, 25, 26, 0.16);
    }
  }

  &__title {
    display: flex;
    align-items: center;
    gap: $g-6;
    color: var(--var-blue-50);
    font-weight: $fw-700;
    .number {
      background-color: var(--var-blue-50);
      width: 52px;
      height: 52px;
      min-width: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: var(--var-white-000);
      font-size: $fs-28;
      font-weight: $fw-700;
    }
  }

  &__subtitle {
    color: var(--var-black-200);
  }
  @media (max-width: $lg) {
    display: grid;
    gap: $g-2;
    &__video {
      grid-row: 3;
    }
  }

  .video-open {
    cursor: unset;
    .card__video_wrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 0%;
      z-index: 1000000;

      video {
        position: absolute;
        z-index: 1000000;
        width: calc(100vw - 65px);
        height: calc(100vh - 60px);
        margin: 30px 30px;
        object-fit: contain;
        background: var(--var-video-bg-video);
        border-radius: $br-1;
        border-radius: $br-18;
      }
      &::before {
        width: 100vw;
        height: 100vh;
        background: rgb(0, 0, 0);
        opacity: 0.7;
        position: fixed;
        z-index: 100000;
        content: '';
      }
    }
  }

  .close-box {
    z-index: 100;
    cursor: pointer;
    position: fixed;
    right: 50px;
    top: 50px;
    width: 48px;
    height: 48px;
    background: rgb(33, 33, 33);
    opacity: 0.9;
    z-index: 10000000;
    border-radius: 8px;

    &:hover {
      opacity: 1;
    }

    .one {
      z-index: 101;
      position: absolute;
      height: 3px;
      width: 32px;
      left: 19%;
      top: 48%;
      transform: rotateZ(45deg);
      background-color: #fff;
      opacity: 0.7;
    }
    .two {
      z-index: 101;
      position: absolute;
      height: 3px;
      width: 32px;
      left: 19%;
      top: 48%;
      transform: rotateZ(135deg);
      background-color: #fff;
      opacity: 0.7;
    }
    @media (max-width: $md) {
      top: 40px;
      right: 30px;
    }
  }
}
</style>
